import {click_event} from './analysis'
import {ACT_NOT_INIT, ACT_NOT_BEGIN, ACT_RUNNING, ACT_END} from '../../constant/act_stat'
import {login} from './login'
import to_casher from './casher'
import isFunction from 'lodash/isFunction'
import isString from 'lodash/isString'


let enable_click = true;

export default function click_handler(event_name, cb, {need_login = false, need_act = true, need_vip = false} = {
                                        need_login: false,
                                        need_act: true,
                                        need_vip: false
                                      }) {
  /**
   *  needlogin:需要登录，
   *  needact:需要活动进行
   */
  if (!enable_click) {
    console.error('点击过快！');
    return false;
  }
  enable_click = false;
  setTimeout(() => {
    enable_click = true
  }, 500);

  console.log(event_name)
  if (!isString(event_name)) {
    throw new Error('click_handler:event_name should be string')
  }
  click_event(event_name + "(点击)");


  if (need_act) {
    if (window.$bus.act.act_stat === ACT_NOT_INIT) {
      window.$toast("在获取活动状态，请稍后...");
      return false;
    }
    else if (window.$bus.act.act_stat === ACT_NOT_BEGIN) {
      console.log("活动未开始")
      window.$toast("活动未开始");

      return false;
    }
    else if (window.$bus.act.act_stat === ACT_END) {
      console.log("活动已结束");
      window.$toast("活动已结束");
      return false;
    }
  }
  //如果需要vip 或者需要login,并且没登录，则唤起登录。
  if (!window.$bus.user.uuid && (need_vip || need_login)) {
    login();
    return false;
  }

  if (need_vip && window.$bus.user.vip_id < 1) {
    let tip_text = '加入芒果TV会员即可领取'
    if (isString(need_vip)) {
      tip_text = need_vip;
    }
    const need_vip_to_cashier =  window.rootdata.need_vip_to_cashier;
    if(need_vip_to_cashier){
      window.$dialog.confirm({
        message: tip_text,
      }).then(() => {
          to_casher();
      }).catch(() => {
        // on cancel
      });
    }else{
      window.$dialog.alert({
        message: tip_text,
      }).then(() => {
      }).catch(() => {
        // on cancel
      });
    }

    return false;
  }

  if (!isFunction(cb)) {
    console.error('click_handler:cb should be function');
    return false;
  }

  click_event(event_name + "(生效)");
  setTimeout(cb, 0);
  return true
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/click.js